import { ApplicationView } from '@aha-app/mvc';
import { InplaceField } from '@aha-app/react-in-place';
import React, { useCallback } from 'react';
import TriggerTemplate from '../UserSelector/TriggerTemplate';

export interface UserValue {
  label: string;
  value: string;
  avatar: string;
  initials: string;
}

export interface UserSelectorProps {
  className?: string;
  editable?: boolean;
  value: UserValue[];
  selectroProps: any;
  onSelect: (value: string, selected: boolean) => void;
  onClear?: () => void;
}

/**
 * This component displays a list of user avatars and has a dropdown for
 * selecting more users. This is used for the watchers attribute and the meeting
 * attendees attribute
 */
const UserSelector: React.FC<UserSelectorProps> = ({
  className,
  editable,
  value,
  selectroProps,
  onSelect,
  onClear,
  ...props
}) => {
  const selectCallback = useCallback(
    ({ payload }) => {
      onSelect(
        payload.item.value || payload.item.data?.value,
        payload.item.selected === 1
      );
    },
    [onSelect]
  );

  const clearCallback = useCallback(() => {
    if (onClear) onClear();
  }, [onClear]);

  return (
    <InplaceField
      {...props}
      {...selectroProps}
      type='selectro'
      selectroType='multiple'
      class={className}
      tabIndex='1'
      value={value}
      data-testid='inplace-field'
      callbacks={{
        select: selectCallback,
        clearAll: clearCallback,
      }}
      disabled={!editable}
      templates={internalProps => ({
        trigger: () => {
          return (
            <TriggerTemplate
              class={internalProps.class}
              showInput={internalProps.showInput}
              focusing={internalProps.focusing}
            />
          );
        },
        ...selectroProps.templates,
      })}
    />
  );
};

export default ApplicationView(UserSelector);
